import { PaymentOrchestrationError } from "./PaymentOrchestrationError";
import { PaymentErrorCategories } from "./PaymentErrorCategories";

/**
 * Error thrown when a payment confirmation call fails (declines, rejections,
 * gateway-reported failures). Unlike other PaymentOrchestrationError
 * subclasses, confirmation errors are expected outcomes (not bugs) so
 * handlePaymentError logs a breadcrumb but does NOT send a Sentry event.
 *
 * The toast uses getExceptionToastDescription (reads .message) rather than
 * .userMessage. This is intentional: for confirmation errors the gateway's
 * decline message is the user-facing message. Both .message and .userMessage
 * are set to the same value at creation in each gateway's handleConfirmError.
 */
export class PaymentConfirmationError extends PaymentOrchestrationError {
  readonly category = PaymentErrorCategories.CONFIRMATION;
  readonly recoverable = false;

  constructor(
    technicalMessage: string,
    options?: {
      userMessage?: string;
      metadata?: Record<string, unknown>;
    }
  ) {
    super(technicalMessage, {
      userMessage:
        options?.userMessage ||
        "Your payment could not be processed. Please try again.",
      metadata: options?.metadata,
    });
  }
}
